import { cn } from '../../lib/cn';
import type { MultiAgentRow } from '../../automationstudio/framework';

type Props = { tasks?: MultiAgentRow[] };

export function MultiAgentCollaborationPanel({ tasks = [] }: Props) {
  return (
    <div className="space-y-2">
      {tasks.map((t) => (
        <div key={t.title} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium">{t.title}</p>
              <p className="mt-0.5 text-xs text-slate-500">{t.agents}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              t.status === 'completed' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {t.status.replace('_', ' ')}
            </span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className="h-full rounded-full bg-brand-500" style={{ width: `${t.progress}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
